import {useRef, useEffect, useCallback} from 'react';

export function useStableCallback<T extends(...args: any[]) => any>(
    fn: T
): T {
    const fnRef = useRef(fn);

    useEffect(() => {
        fnRef.current = fn;
    }, [fn]);

    const stableFn = useCallback((...args: Parameters<T>) => {
        return fnRef.current(...args);
    }, []);

    return stableFn as T;
}
